import {
  faGhost,
  faSpider,
  faHorse,
  faCrow,
  faDragon,
  faHatWizard,
  faBat,
  faHatWitch,
  faAlicorn,
  faSnake,
  faSquirrel,
  faHoodCloak,
  faHelmetBattle,
} from "@fortawesome/pro-duotone-svg-icons";

export const AVATAR_ICONS = [
  faGhost,
  faSpider,
  faHorse,
  faCrow,
  faDragon,
  faHatWizard,
  faBat,
  faHatWitch,
  faAlicorn,
  faSnake,
  faSquirrel,
  faHoodCloak,
  faHelmetBattle,
];
export const AVATAR_COLOURS = ["#04E762", "#F5B700", "#E54599", "#007FE2", "#89FC00", "#66C7F4", "#FDE74C", "#ED3856"];
